import { Dialog, DialogContent, DialogContentText, Box } from '@mui/material';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { styled } from '@mui/material/styles';
import GrowDialogTransition from 'components/modal/GrowDialogTransition';
import CustomDialogTitle from 'components/modal/CustomDialogTitle';

type StatusModalProps = {
  content: ReactNode;
  open: boolean;
  onClose?: () => void;
};

const ContentModal = ({ content, open, onClose }: StatusModalProps) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        top: -200,
        '& .MuiDialog-paper': { borderRadius: '8px' },
      }}
      TransitionComponent={GrowDialogTransition}
    >
      <CustomDialogTitle onClose={onClose} closeIconSize={26} sx={{ height: 50, pb: 0 }} />
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

const $Title = styled(Box, { label: 'ConfirmationDialogTitle' })(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 700,
  color: 'black',
}));

export default ContentModal;
